import { Component, output, signal, input, effect, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
 
@Component({
  selector: 'app-image-upload',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './image-upload.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./image-upload.component.scss'],
})
export class ImageUploadComponent {
  readonly currentImage = input<File>();
  readonly imageSelected = output<File|undefined>();
 
  protected readonly isDragging = signal(false);
  protected readonly selectedFile = signal<File | undefined>(undefined);
  protected readonly previewUrl = signal<string | undefined>(undefined);

  constructor(){
    effect(()=>{
      this.setFile(this.currentImage(),true);
    });
  }
 
  protected onFileSelected(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) this.setFile(file);
  }
 
  protected onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragging.set(true);
  }
 
  protected onDragLeave(event: DragEvent): void {
    this.isDragging.set(false);
  }
 
  protected onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragging.set(false);
    const file = event.dataTransfer?.files?.[0];
    if (file?.type.startsWith('image/')) this.setFile(file);
  }
 
  private setFile(file: File|undefined, supressEmit?:boolean): void {
    this.selectedFile.set(file);
    if(file) this.previewUrl.set(URL.createObjectURL(file));
    else this.previewUrl.set(undefined)
    if(!supressEmit) this.imageSelected.emit(file);
  }
}